import request from '@/utils/request';

export interface IUserData {
  userName: string;
  password: string;
  token?: string;
}

export interface IUpdatePassword {
  oldPassword: string;
  newPassword: string;
  newPasswordRe: string;
}

export interface IBindMobile {
  verifyCode: string;
  mobile: string;
}

export interface ISumbitPassword extends IUpdatePassword {
  userName: string;
}

export interface IClientScreenInfo {
  windowScreenHeight: number;
  windowScreenWidth: number;
  windowScreenAvailHeight: number;
  windowScreenAvailWidth: number;
  windowInnerHeight: number;
  windowInnerWidth: number;
  userAgent: string;
}

export interface IUpdatePasswordwithCode {
  verifyCode: string;
  mobile: string;
  password: string;
  passwordRe: string;
}

export interface IVerifiCation {
  username: string;
  mobile: string;
  verifyCode: string;
}

export class UserApiSerivce {
  static login(data: IUserData, target?: string) {
    return request.post(
      '/passport/api/login-for-web',
      Object.assign(data, { target })
    );
  }
  static fplLogin(data: IUserData) {
    return request.get(
      `${process.env.VUE_APP_FPL_SERVERS_URL}${process.env.VUE_APP_FPL_ENV}-api/auth/set-cookie-4pl`,
      {
        username: data.userName,
        password: data.password,
        token: data.token,
      },
      {
        withCredentials: true,
      }
    );
  }
  static checkPassword(data: IUserData) {
    return request.post('/passport/api/password-policy-cipher', data);
  }
  static changePassword(data: ISumbitPassword) {
    return request.post('/passport/api/change-password-cipher', data);
  }
  static getPasswordPolicy() {
    return request.get('/passport/api/password-policy/search');
  }
  static getMenuTree() {
    return request.get('/passport/api/menu-tree');
  }
  static getPermission(): Promise<any> {
    return request.get('/passport/api/authenticate-for-web');
  }
  static logout() {
    return request.post('/passport/api/logout');
  }
  static saveClientScreenInfo(data: IClientScreenInfo) {
    return request.post('/api/tms/client/upload_screen_config', data);
  }
  static createCode(data: string) {
    return request.get(
      `/passport/api/verify-code/generate-send-message/${data}`
    );
  }
  static sessioneCode(data: string) {
    return request.get(
      `/passport/api/verify-code/generate-send-message-by-session/${data}`
    );
  }
  static updatePassword(data: IUpdatePasswordwithCode) {
    return request.post('/passport/api/verify-code/update-password', data);
  }
  static verifiCation(data: IVerifiCation) {
    return request.post('/passport/api/verify-code/verification', data);
  }
  static bindMobile(data: IBindMobile) {
    return request.post('/passport/api/verify-code/bind-mobile', data);
  }
  static getUserInformation() {
    return request.get('/passport/api/user-information');
  }
  static onIwmsLogin() {
    return request.get('/passport/api/iwms-login');
  }
  static get4PLTokenWithOAToken(data: { lsmyToken: string }) {
    return request.get('/passport-portal/api/set-cookie', data);
  }
  static getFPLTokenWithOAToken(data: { lsmyToken: string }) {
    return request.get('/fpl-api/auth/setCookie', data);
  }
}
